import { render } from "./CompetenciesCreate.vue?vue&type=template&id=c47ba3a0"
import script from "./CompetenciesCreate.vue?vue&type=script&lang=js"
export * from "./CompetenciesCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__